// PanelEmpty — shared empty-state line for right-rail / discovery panels.
//
// Keeps a module with no data from rendering as a bare titled card (review #6):
// render <PanelEmpty> in place of the list when the data array is empty.
import styled from 'styled-components';

export const PanelEmpty = styled.p`
  position: relative;
  margin: 0;
  padding-left: 12px;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 1.45;
  color: ${({ theme }) => theme.color.textMuted};
  /* The empty rule: a short 2px hairline at the left, so a section with
     nothing in it reads as a deliberately blank line on a ledger rather than
     a titled box with nothing inside. */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.3em;
    width: 2px;
    height: 1em;
    background: ${({ theme }) => theme.color.hairSoft};
  }
`;
